import { Box, Grid, Typography, useMediaQuery } from "@mui/material"
import PhoneImg from "../../assets/img/cellphone.png"
import Logo from "../../assets/img/logo animation.svg"
import { useLocation } from "react-router-dom"
import { QRCodeSVG } from "qrcode.react"
import { useEffect } from "react"
import useAuth from "../../context/auth"

export const DesktopAccess = () => {
    const { state } = useLocation()
    const { isMobile } = useAuth()
    const breakComponents = useMediaQuery("(max-width:1000px)")

    return (
        <Grid
            container
            minHeight="100vh"
            minWidth="100vw"
            display="flex"
            direction="row"
            gap="5rem"
            flexWrap={breakComponents ? "wrap-reverse" : "nowrap"}
            alignItems="center"
            justifyContent="center"
            sx={{
                background: "linear-gradient(45.72deg, #C4E0FC 20.14%, #FFFFFF 81.44%)",
                overflowX: "hidden",
                height: "100vh", // Definindo a altura explícita para garantir que o overflow funcione
                width: "100vw",  // Garantir que a largura seja 100% da tela
                position: "relative",
            }}
        >
            {/* <img
                src={PhoneImg}
                alt="phone img"
                style={{
                    width: "46.3rem",
                    height: "72.8rem",
                }}
            /> */}

            <Grid
                maxWidth={"80rem"}
                display={"flex"}
                direction={"column"}
                gap={"2rem"}
                alignItems={"center"}
                justifyContent={"center"}
            >
                <Typography fontFamily={"Nexa Heavy"} fontSize={"4.6rem"} fontWeight={900} textAlign={"center"} mt={breakComponents ? 5 : 0}>Olá, bem vindo (a) à</Typography>

                <img
                    src={Logo}
                    alt="phone img"
                    style={{
                        width: isMobile ? "90%" : "40.2rem",
                        height: isMobile ? "auto" : "19.3rem",
                    }}
                />

                <Typography fontFamily={"Nexa ExtraLight"} fontSize={"3rem"} fontWeight={100} textAlign={"center"} maxWidth={"70rem"}>Para acessar a plataforma Gyroo, abra a câmera do seu celular e aponte para o QR Code abaixo</Typography>

                <Box
                    sx={{
                        width: "24.8rem",
                        height: "24.8rem",
                        borderRadius: "20px",
                        background: "linear-gradient(90deg, #1D22E6 0%, #01E9FE 100%)",
                        padding: "7px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <Box
                        sx={{
                            width: "100%",
                            height: "100%",
                            borderRadius: "inherit",
                            background: "#fff",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center"
                        }}
                    >
                        <QRCodeSVG
                            value={state?.path ? window.location.origin + state?.path : window.location.href}
                            style={{
                                width: "90%",
                                height: "90%"
                            }} />
                    </Box>
                </Box>
            </Grid>
        </Grid>
    )
}